module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"title":"评论排序标准"}}')
  delete Component.options._Ctor
}
